module.exports = __webpack_public_path__ + "img/subject_banner7.8498ca48.png";